import Error from '../../../components/Error/Error';
import HeaderTitle from '../../../components/Title/HeaderTitle';
import Images from '../../../state/stores/Image/images';
import React, { FC, Fragment, useEffect, useRef } from 'react';
import Show from '../../../components/Show/Show';
import Tooltip from '../../../components/Tooltip/Tooltip';
import { ActivityCard } from '../../../components/pairs/ActivityCard/Container';
import { Body1Reg, Caption1Bold } from '../../../config/designSystem/typography';
import { COLORS } from '../../../config/designSystem/Colors';
import { Drawer } from '../../../components/Modal/Drawer';
import { DropShadowLightCloseStyle } from '../../../config/designSystem/Shadow';
import { GET_DASHBOARD_SESSION } from '../../../state/queries/Session';
import { GET_DASHBOARD_SURVEY } from '../../../state/queries/Survey';
import { Image, Pressable, ScrollView, View, ViewStyle } from 'react-native';
import { NotificationCard } from '../../../components/Cards/Notification/Notification';
import { ProgramBackground } from '../../../components/Program/ProgramBackground';
import { ProgramCard } from '../../../components/Program/ProgramCard';
import { ProgramSessionCard } from '../../../components/Program/ProgramSessionCard';
import { ProgressExerciseCard } from '../../../components/Program/ProgramExerciseCard';
import { SESSION_OF_TYPE } from '../../../state/queries/Session';


import Loading from '../../../components/Loading/Loading';
import { BOTTOM_SPACING_SCROLLVIEW, SPACING } from '../../../config/designSystem/Spacing';
import { CTACard } from '../../../components/Cards/CTA/CTACard';
import { HORIZONTAL_MARGIN_DASHBOARD, MARGIN_BETWEEN_CARDS } from '../../../constants/dashboardLayout';
import { ModalFeedbackWhenChangingProgram } from '../../../components/Program/ModalFeedbackWhenChangingProgram';
import { SectionTitle } from '../../../components/Title/SectionTitle';
import { SolarFlowerIcon } from '../../../assets/images/solar/flower/Flower';
import { StyleProp } from 'react-native';
import { SwipingList } from '../../../components/SwipingList/SwipingList';
import { branchingKey, chooseNewPathKey, dashboardStackKey, privateKey, reckoningResultKey, sessionStackKey, visitedPageDashboardKey } from '../../../constants/routeKeys';
import { client } from '../../../config/apollo/client';
import { concatPath } from '../../../utils/links/concatPath';
import { loadString, saveString } from '../../../utils/storage';
import { logAmplitude } from '../../../utils/analytics/analytics';
import { observer } from 'mobx-react';
import { router, useFocusEffect, useScrollToTop } from 'expo-router';
import { useIsConnected } from '../../../hooks/useIsConnected';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStores } from '../../../hooks/useStores';









export const tooptipStyle: StyleProp<ViewStyle> = {
  borderWidth:0,
  borderRadius: SPACING['sp-12'],
  ...DropShadowLightCloseStyle
};

export const contentTooptipStyle: StyleProp<ViewStyle> = [{
  borderLeftWidth: SPACING['sp-4'],
  padding: SPACING['sp-12'],
  backgroundColor: COLORS.surface.contrast,
  borderColor: COLORS.border.accent,

  borderRadius: SPACING['sp-12'],
  height: '100%'
}
];

export const TIME_OUT_AFTER_SCROLL = 1000;
const MODAL_CLOSE_DELAY = 600;

const Dashboard: FC = observer(() => {
  const rootStore = useStores();
  const [freshStartModalVisible, setFreshStartModalVisible] = React.useState(false);

  const [firstSessionLayout, setFirstSessionLayout] = React.useState({x: 0, y: 0, width:0,height:0});

  const connected = useIsConnected();


  const showOnboardingButton = !rootStore?.user?.user?.onboardingDone;
  const reckoningData = rootStore?.reckoning?.getReckoningInDashboard();
  const firstName = rootStore?.user?.user?.firstName ? rootStore?.user.user.firstName  : '';
  const [sessionId, setSessionId] = React.useState<string>('');
  // the mental health check due for the user: the session wrapping that block
  const [mhcSessionId, setMhcSessionId] = React.useState<string>('');
  // The ScrollView below is the element that actually scrolls; registering the nested
  // FlatList here meant tapping the tab to scroll to top did nothing.
  const scrollViewRef = useRef<ScrollView>(null);
  useScrollToTop(scrollViewRef);
  const insets = useSafeAreaInsets();

  const activePath = rootStore?.user?.activePath;
  const activities = rootStore?.activity.startedActivities;
  // an accepted challenge replaces the legacy exercise card it was converted
  // from: one card per thing to do today
  const exercises = rootStore?.exercise.getDashboard.filter(
    exercise => !activities.some(activity => activity.migratedFromExercice && activity.migratedFromExercice === exercise._id)
  );


  let path = null;
  let programSessionId = null;
  let todaySessions = null;
  const programExist = rootStore?.path?.programExist;

  if(activePath) {
    path = rootStore?.path?.getPath(activePath);
    programSessionId = rootStore?.session?.getCurrentSession(activePath);
    todaySessions = rootStore?.session?.getTodaySessions(activePath);
  }
  const moreThanOneTodayElement =  (todaySessions?.length + exercises?.length + activities?.length)>1;
  const moreThanZeroTodayElement = (programExist || exercises.length>0 || activities.length>0);
  const counter = rootStore?.user?.stat?.nbSessionsDone;
  const pathFinishedToday = path?.programFinishedToday;
  const designSystemColor = path?.activePathStatus !== 'FINISHED'?path?.designSystemColor:undefined;
  const alreadyShownCongrats = path?.hasShownCongrats;
  const pathFinishedModalVisible = !alreadyShownCongrats && !!pathFinishedToday;
  const flowerColors = COLORS?.[designSystemColor as keyof typeof COLORS];
  const allIsDone = rootStore?.exercise?.allExercisesFinishedToday;
  const allActivitiesDoneToday = activities.every(a => rootStore?.activity.isDoneToday(a._id));
  const sessionDoneToday = rootStore?.path?.getIsDoneToday(activePath);
  const todayIsDone = allIsDone && allActivitiesDoneToday && sessionDoneToday;
  const flowerColor = (!activePath || !flowerColors)? COLORS.surface.tertiary:(todayIsDone? flowerColors?.[500]: flowerColors?.[100]);

  const [indexOnboarding,setIndexOnboarding] = React.useState(-1);
  const [isVisible, setIsVisible] = React.useState(false);


  const  [firstTodaySessionHeight, setFirstTodaySessionHeight] = React.useState(0);
  const  [afterSectionHeight, setAfterSectionTitleHeight] = React.useState(0);

  const  [afterHeaderHeight, setAfterHeaderHeight] = React.useState(0);

  const [loadingDashboardSession, setLoadingDashboardSession] = React.useState(false);
  const getProfileLoading = rootStore?.user?.stateGetProfile === 'pending';

  const [onboardingTransition, setOnboardingTransition] =  React.useState(false);

  const [todaySessionOnboarding, setTodaySessionOnboarding] = React.useState(false);
  const [flowerOnboarding, setFlowerOnboarding] = React.useState(false);

  const startOnboarding = indexOnboarding === 0 && !!path && !!programSessionId && !onboardingTransition && !sessionDoneToday;
  const reckoningResultData = rootStore?.user?.user?.recommendedPages;




  // I feel like adding a useFocusEffect breaks the tooltip. One needs to be check that when adding a useFocusEffect.





  useEffect(() => {
    // These timers used to re-check `indexOnboarding` from their own closure, which
    // is stale by the time they fire. Advancing past the last step scheduled a timer
    // that still saw the old index and re-opened the tooltip AFTER the tour ended,
    // leaving a modal nothing could dismiss. Cancel on cleanup instead of re-reading.
    let timer: ReturnType<typeof setTimeout> | undefined;

    if(indexOnboarding === 3 ) {
      if(scrollViewRef.current) {
        scrollViewRef.current.scrollTo({ y:  firstSessionLayout.y + afterHeaderHeight + firstTodaySessionHeight + afterSectionHeight, animated: true });
      }
      timer = setTimeout(() => setTodaySessionOnboarding(true), TIME_OUT_AFTER_SCROLL);

    } else if(indexOnboarding === 4 ) {
      if(scrollViewRef.current) {
        scrollViewRef.current.scrollTo({ y: 0, animated: true });
      }
      timer = setTimeout(() => setFlowerOnboarding(true), TIME_OUT_AFTER_SCROLL);
    } else {
      setFlowerOnboarding(false);
      setTodaySessionOnboarding(false);
    }

    return () => { if(timer) clearTimeout(timer); };
  }, [indexOnboarding]);



  // the cards depend on what the user just did (check-up done, onboarding
  // done): fetched again each time the dashboard regains focus — memoised,
  // so the fetch does not re-run on every render while focused
  useFocusEffect(React.useCallback(() => {
    if (rootStore?.user?.user) {
      getDashboardSession();
    }
  }, [rootStore?.user?.user?._id]));

  useFocusEffect(() => {
    const checkIfOnboardingStart = async () => {
      const val = await loadString('activePath');
      if(val && val === 'true') {
        setIsVisible(true);
      }
    };
    checkIfOnboardingStart();
  });

  // The "why did you change path?" modals and this tour are both modals. Opened
  // together, the tour measured its highlight under the feedback sheet and lit the
  // wrong area: the tour now waits until the feedback flow is closed, plus the time
  // the closing modal needs to animate out.
  // the store flag is set synchronously with the path switch, before the dashboard
  // regains focus; the modal's own report (thank-you step included) only arrives
  // once the dashboard renders again, which can be after the tour was armed
  const feedbackPending = !!rootStore?.user?.needCollectFeedbackAfterProgramChanged;
  const [feedbackFlowOpen, setFeedbackFlowOpen] = React.useState(feedbackPending);
  const feedbackFlowShown = useRef(feedbackFlowOpen);
  const onFeedbackFlowOpenChange = React.useCallback((open: boolean) => {
    if(open) {
      feedbackFlowShown.current = true;
    }
    setFeedbackFlowOpen(open);
  }, []);

  useEffect(() => {
    if(feedbackPending) {
      feedbackFlowShown.current = true;
    }
    if(!isVisible || indexOnboarding !== -1 || feedbackFlowOpen || feedbackPending) {
      return;
    }
    const timer = setTimeout(() => {
      setIndexOnboarding(0);
      // Consume the trigger as soon as the tour is SHOWN, not once it is completed.
      // The 'activePath' storage flag is what arms this tour, and it used to be cleared
      // only when the user advanced past the last step (onNextOnboarding, index >= 4).
      // Anyone who backed out early -- or simply killed the app mid-tour -- left it at
      // 'true', so the tour restarted on EVERY Dashboard focus, not just every launch.
      // Recording DASHBOARD here closes the same loop server-side: loadVisitedPages
      // re-arms the flag while DASHBOARD is missing from the profile, so without this a
      // reinstall would start it over again too. Showing the tour once is the contract;
      // finishing it is the user's choice.
      saveString('activePath','false');
      rootStore?.onboarding?.setVisitedPages(visitedPageDashboardKey);
    }, feedbackFlowShown.current ? MODAL_CLOSE_DELAY : 0);

    return () => clearTimeout(timer);
  }, [isVisible, feedbackFlowOpen, feedbackPending]);


  useEffect(() => {
    if(!programExist && rootStore?.user?.freshStartShown && rootStore?.user?.state === 'done' &&
      (rootStore?.user?.stat?.number_of_path_started || 0)>0) {
      setFreshStartModalVisible(true);
    } else {
      setFreshStartModalVisible(false);
    }

  }, [programExist,rootStore?.user?.state,rootStore?.user?.freshStartShown]);



  useEffect(() => {
    if(rootStore?.user?.user) {
      getDashboardSession();
    }

  },[rootStore?.user?.user]);





  useEffect(() => {
    if(!!path?._id && !!programSessionId?._id) {
      rootStore?.session.loadContentOfSession(path?._id, programSessionId._id);
    }
  }, [!!path?._id, programSessionId?._id]);

  const getDashboardSession = async () => {
    setLoadingDashboardSession(true);
    const {data} = await client.query({ query: GET_DASHBOARD_SESSION});
    if(data && 'dashboardSession' in data) {
      setSessionId(data?.dashboardSession?._id);
    }
    try {
      const { data: surveyData } = await client.query({ query: GET_DASHBOARD_SURVEY, fetchPolicy: 'network-only' });
      const surveyId = surveyData?.dashboardSurvey?._id;
      if (surveyId) {
        const { data: sessionData } = await client.query({ query: SESSION_OF_TYPE, variables: { sessionType: 'mhc' } });
        setMhcSessionId(sessionData?.sessionOfType?._id || '');
      } else {
        setMhcSessionId('');
      }
    } catch (error) {
      console.error('Error fetching the dashboard survey:', error);
    }
    setLoadingDashboardSession(false);
  };


  const labels = rootStore?.language.translate.MOBILE?.HOME;





  const onNextOnboarding = () => {
    setOnboardingTransition(true);
    setIndexOnboarding(indexOnboarding + 1);

    if(indexOnboarding >= 4) {
      rootStore?.onboarding?.setVisitedPages(visitedPageDashboardKey);
      saveString('activePath','false');

      setFlowerOnboarding(false);
    }
    if(indexOnboarding === 3) {
      setTodaySessionOnboarding(false);
    }

  };

  const onRequestCloseToolTip = () => {
    setOnboardingTransition(false);

  };



  // the finished-path card: on to the next path, not a dead end
  const goToChooseANewPath = () => {
    router.navigate({
      pathname: concatPath([privateKey, dashboardStackKey, chooseNewPathKey], -1) as string,
      params: { filterOutId: activePath },
    });
  };

  // "Go to next session": adds the next session to today AND opens it (the
  // card alone appeared above the fold, which read as a dead button)
  const onPressNextSession = async () => {
    const nextSessionId = await rootStore?.path?.addExtraTodaySession(activePath as string);
    logAmplitude('Next Session Gone', {
      pathId: path?.humanReadableId,
      previousSessionId: todaySessions?.[todaySessions.length-1]?.humanReadableId,
      order: path?.numberSessions
    });
    if (!nextSessionId) {
      return;
    }
    logAmplitude('Session Started', {
      pathId: path?.humanReadableId,
      sessionId: nextSessionId,
      from: 'next_session_button'
    });
    router.navigate({
      pathname: concatPath([privateKey, sessionStackKey, branchingKey], -1) as string,
      params: {
        pathId: activePath,
        sessionId: nextSessionId,
        fromPath: encodeURIComponent(true),
        fromReckoning: encodeURIComponent(false),
      }});
  };

  const onPressMhc = () => {
    router.navigate({
      pathname: concatPath([sessionStackKey,branchingKey]) as string,
      params: {
        sessionId: mhcSessionId,
        reckoningId: null,
        fromPath: encodeURIComponent(false),
        fromReckoning: encodeURIComponent(false),
        color: encodeURIComponent('#a6ceda'),
        secondaryColor: encodeURIComponent('#4f9eb5')
      }
    });
  };

  const onPressTakeSurvey = () => {
    router.navigate({
      pathname: concatPath([sessionStackKey,branchingKey]) as string,
      params: {
        sessionId: sessionId,
        reckoningId: null,
        fromPath: encodeURIComponent(false),
        fromReckoning: encodeURIComponent(false),
        color: encodeURIComponent('#a6ceda'),
        secondaryColor: encodeURIComponent('#4f9eb5')
      }
    });


  };




  const onPressReckoning = (sessionId: string, reckoningId: string, onboardingDoneWhenThisReckoningIsDone?: boolean) => {
    router.navigate({
      pathname: concatPath([sessionStackKey, branchingKey], 1) as string,
      params: {
        sessionId: sessionId,
        reckoningId: reckoningId,
        onboardingDoneWhenThisReckoningIsDone:encodeURIComponent(onboardingDoneWhenThisReckoningIsDone as boolean),
        fromPath: encodeURIComponent(false),
        fromReckoning: encodeURIComponent(true),
        color: encodeURIComponent('#a6ceda'),
        secondaryColor: encodeURIComponent('#4f9eb5')
      }
    });


  };

  const onPressResult = () => {
    const feature = rootStore?.user?.user?.recommendedPages?.feature;
    const strategy = rootStore?.user?.user?.recommendedPages?.recommendationStrategy;
    if(!feature || !strategy) {
      return;
    }

    router.navigate({
      pathname: concatPath([reckoningResultKey], 1) as string,
      params: {
        featureId: feature,
        strategyId: strategy
      }
    });
  };

  const renderOnboarding = (height: number) => {
    return(
      <NotificationCard
        mainTextLabel={labels?.ONBOARDING_SURVEY_TEXT }
        titleLabel={labels?.ONBOARDING_SURVEY_TITLE}
        ctaLabel={labels?.START_ONBOARDING_SURVEY}
        onPressCta={onPressTakeSurvey}
        close={false}
        sizeImage={40}
        image={Images.illustrations.onboarding_survey}
        height={height}
      />
    );
  };

  const renderMhc = (height: number) => {
    return(
      <NotificationCard
        mainTextLabel={labels?.MHC_TEXT}
        titleLabel={labels?.MHC_TITLE}
        ctaLabel={labels?.START_MHC}
        onPressCta={onPressMhc}
        close={false}
        sizeImage={40}
        image={Images.illustrations.onboarding_survey}
        height={height}
      />
    );
  };

  const renderReckoning = (height: number) => {
    return(
      <NotificationCard
        mainTextLabel={reckoningData?.invitation }
        titleLabel={labels?.TITLE_RECKONING}
        ctaLabel={labels?.START_RECKONING}
        onPressCta={() => onPressReckoning(reckoningData?.session, reckoningData?._id, reckoningData?.onboardingDoneWhenThisReckoningIsDone)}
        close={false}
        sizeImage={40}
        image={Images.illustrations.reckoning_survey}
        height={height}

      />
    );
  };

  const renderResult = (height: number) => {
    return(
      <NotificationCard
        mainTextLabel={labels?.CHECK_RESULT_TEXT}
        titleLabel={labels?.CHECK_RESULT_TITLE}
        ctaLabel={labels?.CHECK_RESULT}
        onPressCta={onPressResult}
        close={false}
        sizeImage={40}
        image={Images.illustrations.reckoning_survey}
        height={height}
      />
    );
  };

  const renderBanners = () =>{

    const elements = [
      {
        show: showOnboardingButton && !!sessionId,
        child:  (height: number) => renderOnboarding(height)
      }, {
        show: reckoningData && reckoningData._id,
        child:  (height: number) => renderReckoning(height)
      },
      {
        show: !!mhcSessionId,
        child:  (height: number) => renderMhc(height)
      },
      {
        show: !!reckoningResultData,
        child:  (height: number) => renderResult(height)
      }
    ];
    return (
      <SwipingList elements={elements}  marginHorizontal={HORIZONTAL_MARGIN_DASHBOARD}/>
    );
  };








  const renderHello = () => {
    const valText = ((labels?.GREETINGS ?? '') + ' ' + firstName + '!').trim();
    return (
      <HeaderTitle title={valText} element={
        <Show when={counter !== null && counter !== undefined} >
          <Tooltip
            isVisible={!onboardingTransition && flowerOnboarding}

            placement="bottom"
            onClose={() => onNextOnboarding()}
            onCloseComplete={onRequestCloseToolTip}
            // allowChildInteraction={false}
            // contentStyle={contentTooptipStyle}
            // tooltipStyle={tooptipStyle}
            from={(
              <Pressable onPress={() => {}} >
                <View  style={[{flexDirection:'row', columnGap: SPACING['sp-4'], zIndex:1}, flowerOnboarding && {backgroundColor:'white'}]}>
                  <Caption1Bold color={COLORS.content.primary}>{counter}</Caption1Bold>
                  <SolarFlowerIcon size={16} />
                </View>
              </Pressable>
            )}

          >
            <Body1Reg> {labels?.ONBOARDING_STEP_4}</Body1Reg>
          </Tooltip>
        </Show>

      } />
    );
  };




  if(rootStore?.categories.state === 'error') {
    return <Error network={!connected} labels={rootStore?.language.translate.MOBILE?.ERROR} />;
  }





  const renderHeader = () => {

    return(
      <>

        <ProgramBackground designSystemColor={designSystemColor} light={true} />

        <View style={{marginTop: (insets?.top  || SPACING['sp-32']) + SPACING['sp-16'],marginHorizontal: HORIZONTAL_MARGIN_DASHBOARD, rowGap: SPACING['sp-40']}}>
          {renderHello()}


          <ProgramCard
            startOnboarding={startOnboarding}
            pathId={activePath}
            indexOnboarding={indexOnboarding}
            onNextOnboarding={onNextOnboarding}
            onboardingTransition={onboardingTransition}
            onCloseComplete={onRequestCloseToolTip}/>

        </View>
      </>
    );

  };

  const noTodayElementCard = () => {
    return(
      <CTACard mainTextLabel={labels?.NO_TODAY_ELEMENT_TEXT} emoji={labels?.NO_TODAY_ELEMENT_TITLE} />
    );
  };

  const onDismissModalPathFinished = () => {
    path?.setShownCongrats();
  };

  const onDismissFreshStart = () => {
    setFreshStartModalVisible(false);
    rootStore?.user?.setReadyForAFreshStartDateShown();
  };

  const renderBackgroundWithIcons = (icon: 'flower' | 'stars') => {
    return(
      <Image source={(icon === 'flower')?Images.illustrations.flower:Images.illustrations.medal} style={{width: 104, height: 104}}  />
    );
  };

  const renderModals = () => {
    return(
      <>
        <Drawer
          mainText={labels?.WELL_DONE}
          buttonMainActionText={labels?.GOT_IT}
          titleText={labels?.PATH_COMPLETED}
          onDismiss={onDismissModalPathFinished}
          onMainAction={onDismissModalPathFinished}
          isVisible={pathFinishedModalVisible}
        >
          {renderBackgroundWithIcons('stars')}
        </Drawer>
        <Drawer
          mainText={labels?.YOU_HAVE_COMPLETED}
          buttonMainActionText={labels?.GOT_IT}
          titleText={labels?.READY_FOR_A_FRESH_START}
          onDismiss={onDismissFreshStart}
          onMainAction={onDismissFreshStart}
          isVisible={freshStartModalVisible}
        >
          {renderBackgroundWithIcons('flower')}
        </Drawer>
        <ModalFeedbackWhenChangingProgram onOpenChange={onFeedbackFlowOpenChange}/>
      </>
    );
  };

  if(loadingDashboardSession || (!!rootStore?.user?.stateSetActivePath && rootStore?.user?.stateSetActivePath !== 'done') || getProfileLoading ||(activePath && rootStore.path?.stateTodaySession === 'pending')) {
    return<Loading />;
  }

  const firstSessionCard = (ts: any) => {
    return(
      <View  onLayout={event => {
        setFirstSessionLayout(event.nativeEvent.layout);
      }}>
        <ProgramSessionCard
          showOnboarding={todaySessionOnboarding && !onboardingTransition}
          onboardingCb={onNextOnboarding}
          onCloseComplete={onRequestCloseToolTip}
          pathId={activePath as string}
          session={ts}
          exercisesBelow={moreThanOneTodayElement} />
      </View>);

  };

  return (
    <View style={{flex:1}}>
      {renderModals()}

      <ScrollView  ref={scrollViewRef}>
        {renderHeader()}
        <View style={{
          marginTop: SPACING['sp-40'],

          rowGap: SPACING['sp-24'],
          marginBottom: BOTTOM_SPACING_SCROLLVIEW}}
        onLayout={event => {
          const { y, width} = event.nativeEvent.layout;
          setAfterHeaderHeight(y);  // Update context with the actual height
        }}>
          {renderBanners()}
          <View style={{marginHorizontal: HORIZONTAL_MARGIN_DASHBOARD}}

          >
            <View onLayout={event => {
              const { y } = event.nativeEvent.layout;
              setFirstTodaySessionHeight(y);
            }}>
              <SectionTitle title={labels?.TODAY} flowerColor={flowerColor} displayAll={false}
                style={{marginVertical: SPACING['sp-16']}}/>
              <Show when={moreThanZeroTodayElement && activePath} fallback={noTodayElementCard()}>
                <View onLayout={event => {
                  const { y } = event.nativeEvent.layout;
                  setAfterSectionTitleHeight(y);
                }}>
                  {todaySessions?.map((ts,index) => {
                    if(index === 0) {
                      return(
                        <Fragment key={index}>
                          {firstSessionCard(ts)}
                        </Fragment>
                      );
                    } else {
                      return(
                        <Fragment key={index}>
                          <ProgramSessionCard
                            showOnboarding={false}
                            pathId={activePath as string}
                            session={ts}
                            key={index}
                            exercisesBelow={((index< todaySessions.length -1) || exercises.length > 0)}
                          />
                        </Fragment>
                      );
                    }
                  })}
                </View>



                <Show when={exercises && exercises.length > 0}>
                  <View>
                    {exercises.map((item, index) => {
                      if (!item) return null;
                      const indexUpdated = programExist? (index+1):index;
                      const isLastOne = (exercises.length-1 === index) && activities.length === 0;
                      const isFirstOne = indexUpdated === 0;
                      const isOnlyOne = isLastOne && isFirstOne;
                      const line = isOnlyOne? 'none' : isFirstOne? 'start': isLastOne? 'end':'both';
                      return (
                        <ProgressExerciseCard key={item._id} exerciseId={item._id} line={line}
                          marginBelow={isLastOne? undefined: MARGIN_BETWEEN_CARDS}/>
                      );
                    })}
                  </View>
                </Show>

                <Show when={activities && activities.length > 0}>
                  <View>
                    {activities.map((item, index) => {
                      if (!item) return null;
                      const indexUpdated = (programExist || exercises.length > 0)? (index+1):index;
                      const isLastOne = activities.length-1 === index;
                      const isFirstOne = indexUpdated === 0;
                      const isOnlyOne = isLastOne && isFirstOne;
                      const line = isOnlyOne? 'none' : isFirstOne? 'start': isLastOne? 'end':'both';
                      return (
                        <ActivityCard key={item._id} activityId={item._id} line={line}
                          marginBelow={isLastOne? undefined: MARGIN_BETWEEN_CARDS}/>
                      );
                    })}
                  </View>
                </Show>
              </Show>

              <Show when={todayIsDone && moreThanZeroTodayElement }>
                <View style={{marginTop: SPACING['sp-24']}}>
                  <Show when={!path?.programFinishedToday}>
                    <CTACard
                      emoji={labels?.YOU_ARE_DONE_EMOJI}
                      titleLabel={labels?.AMAZING_YOU_ARE_DONE}
                      mainTextLabel={labels?.TAKE_SOME_TIME}
                      buttonLabel={labels?.GO_TO_NEXT_SESSION}
                      onPressButton={onPressNextSession}
                    />
                  </Show>
                  <Show when={!!path?.programFinishedToday}>
                    <CTACard
                      emoji={labels?.YOU_ARE_UNSTOPPABLE_EMOJI}
                      titleLabel={labels?.YOU_ARE_UNSTOPPABLE}
                      mainTextLabel={labels?.TAKE_A_MOMENT}
                      buttonLabel={labels?.CHOOSE_NEW_PATH || 'Choose a new path'}
                      onPressButton={goToChooseANewPath}
                    />
                  </Show>
                </View>
              </Show>
            </View>
          </View>
        </View>
      </ScrollView>
    </View>
  );
});

export default Dashboard;
